import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { SubmissionError } from 'redux-form';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import SettingsRoundedIcon from '@material-ui/icons/SettingsRounded';
import NotificationSystem from 'rc-notification';

import { NOTIFICATION_NODE_STYLE } from 'constants/misc';
import BasicNotification from 'components/Notification';
import { updateCampaign } from 'redux/actions/campaignActions';
import Dialog from 'components/modals/Dialog';
import DialogTitle from 'components/modals/DialogTitle';
import { secondaryText } from 'themes/colors';
import SettingsForm from './SettingsForm';


class SettingsCreate extends PureComponent {
  static propTypes = {
    updateCampaign: PropTypes.func.isRequired,
    campaign: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      loading: PropTypes.bool,
      loaded: PropTypes.bool,
    }).isRequired,
    match: PropTypes.shape({
      params: PropTypes.shape({
        id: PropTypes.string,
      }),
      path: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }).isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
    this.toggle = this.toggle.bind(this);
  }

  componentDidMount() {
    // eslint-disable-next-line no-return-assign
    NotificationSystem.newInstance({}, n => this.notification = n);
  }

  componentWillUnmount() {
    this.notification.destroy();
  }

  async onSubmit(formData) {
    try {
      await this.props.updateCampaign(
        this.props.match.params.id,
        {
          name: formData.name,
          account: formData.account.value,
          campaign_manager: formData.campaign_manager ? formData.campaign_manager.value : undefined,
          email_service_provider_configs: formData.email_service_provider_configs.map((config) => {
            const emailSettings = formData[config.value];
            return {
              id: config.value,
              ...emailSettings,
            };
          }),
        },
        true, // we need to use seamless to prevent loaders on Campaign Detail
      );
      this.toggle();
      this.showNotification();
    } catch (error) {
      if (error.errors) {
        throw new SubmissionError(error.errors);
      }
    }
  }

  showNotification = () => {
    this.notification.notice({
      content: <BasicNotification
        color="success"
        message="Campaign successfully updated"
      />,
      duration: 2,
      closable: false,
      style: NOTIFICATION_NODE_STYLE,
      className: 'alert--colored right-up',
    });
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }

  render() {
    return (
      <React.Fragment>
        <Tooltip title="Open Settings">
          <IconButton onClick={this.toggle}>
            <SettingsRoundedIcon style={{ color: secondaryText, opacity: 0.8 }} />
          </IconButton>
        </Tooltip>
        <Dialog
          open={this.state.isOpen}
          onBackdropClick={this.toggle}
          scroll="body"
        >
          <DialogTitle id="dialog-title" disableTypography>
            Settings
          </DialogTitle>
          <SettingsForm toggleModal={this.toggle} onSubmit={data => this.onSubmit(data)} />
        </Dialog>
      </React.Fragment>
    );
  }
}


export default compose(
  withRouter,
  connect(
    state => ({
      campaign: state.campaign,
    }),
    { updateCampaign },
  ),
  withNamespaces('common'),
)(SettingsCreate);
